/**
 * Where each role lands after signing in.
 *
 * A moliyachi goes straight to `Moliya`, as the prototype does: their working day is
 * the approval queue, and making them pass through a dashboard first would add a click
 * to the thing they came for. `Bosh sahifa` still exists for them — it shows the kassa
 * strip and the queue size — it just is not the landing screen.
 *
 * Its own module so the router file keeps exporting only the route table; mixing
 * components and plain values in one file breaks fast refresh.
 */
import type { Role } from "@/api/types";
import type { AuthUser } from "@/store/auth";

export const DEFAULT_LANDING = "/";
export const PLATFORM_LANDING = "/platforma";

const LANDING_BY_ROLE: Partial<Record<Role, string>> = {
  moliyachi: "/moliya",
};

export function landingFor(role: Role | null | undefined): string {
  if (role === undefined || role === null) {
    return DEFAULT_LANDING;
  }
  return LANDING_BY_ROLE[role] ?? DEFAULT_LANDING;
}

/**
 * The landing for a resolved user. A platform admin who belongs to no agency has no
 * tenant to show, so they go to the panel; everyone else follows their role.
 */
export function landingForUser(user: AuthUser | null): string {
  if (user === null) {
    return DEFAULT_LANDING;
  }
  if (user.tenant === null && user.is_platform_admin) {
    return PLATFORM_LANDING;
  }
  return landingFor(user.role);
}
